function LoadingOptions() {
    return (
        <div className="bg-yellow-100 border space-x-1 flex border-yellow-200 text-olm-black text-sm font-semibold py-2 my-1 px-2">
            <span>Loading...</span>
        </div>
    )
}

export default LoadingOptions
